import { getCsrfToken } from './csrfTokenStore'

// we do not need it in SPA
const xsrf = {
  xsrfHeaderName: 'X-CSRFToken',
}

const commonHeaders = {
  'X-Ironscales-Client-Type': 'react',
}

export function getDefaultHeaders() {
  let defaultHeaders = {
    ...commonHeaders,
  }

  const csrfToken = getCsrfToken()
  if (csrfToken) {
    defaultHeaders = {
      ...defaultHeaders,
      [xsrf.xsrfHeaderName]: csrfToken,
    }
  }

  return defaultHeaders
}
